import { render, staticRenderFns } from "./SupplyTable.vue?vue&type=template&id=b4d7b96e&scoped=true&"
import script from "./SupplyTable.vue?vue&type=script&lang=js&"
export * from "./SupplyTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplyTable.vue?vue&type=style&index=0&id=b4d7b96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7b96e",
  null
  
)

export default component.exports